import { TableColumn } from "./dataInterface";

export const productTableColumn: TableColumn = {
  title: "商材一覧",
  detail: true,
  detailTitle: "商材詳細",
  detailColumn: "詳細",
  detailKey: ["id"],
  addTitle: "商材登録",
  editAuth: ["マスターアカウント", "スタッフアカウント"],
  tableFunction: [
    {
      name: "取扱い停止・再開",
      width: "120px",
      auth: ["マスターアカウント", "スタッフアカウント"],
    },
  ],
  postCSVTitle: "",
  dataColumn: [
    {
      key: "high_rank_company_name",
      name: "上位店名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "high_rank_company",
      detail: true,
      edit: true,
      editType: "text",
      editId: "high_rank_company_id",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "high_rank_company_id",
      name: "上位店名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "id",
      add: true,
      addType: "high_rank_company",
      addMessage: "",
    },
    {
      key: "category_name",
      name: "カテゴリ",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "category",
      detail: true,
      edit: true,
      editType: "list",
      editId: "id",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "category_id",
      name: "カテゴリ",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "id",
      add: true,
      addType: "category",
      addMessage: "",
    },
    {
      key: "product_name",
      name: "商材名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "product",
      detail: true,
      edit: true,
      editType: "text",
      editId: "id",
      add: true,
      addType: "text",
      addMessage: "",
    },
    {
      key: "no_entry_flg",
      name: "取扱い",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "50px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      detail: true,
      edit: false,
      editType: null,
      editId: "id",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "product_key",
      name: "契約に用いるキー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      editType: "list",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "product_contract_number",
      name: "申込番号付与の設定",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      editType: "list",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "cancell_action",
      name: "解約の設定",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "100px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      editType: "list",
      detail: true,
      edit: true,
      editId: "id",
      add: true,
      addType: "list",
      addMessage: "自社商材以外は「手動解約不可」としてください。",
    },
    {
      key: "payment_method",
      name: "支払方法",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "bubun",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: true,
      addType: "payment_method",
      addMessage: "支払方法の指定がなければ、空欄としてください。",
    },
    {
      key: "product_option",
      name: "質問",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: "product_option",
      addMessage: "",
    },
  ],
  subTable: [
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "リストIDグループ一覧",
      subTableColumnLength: "list_id_group_length",
      detailKey: ["product_id", "customer_list_group_id"],
      subTableColumnNameWidth: "150px",
      subTableDetail: false,
      subTableDetailTitle: "リストIDグループ詳細",
      subTableAdd: false,
      subTableAddTitle: "リストIDグループ追加",
      subTableAddTitleWidth: "90px",
      subTableEdit: false,
      subTableEditTitle: "リストIDグループ編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: [],
      tableFunction: [],
      subDataColumn: [
        {
          key: "product_id",
          name: "商材名",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "product_id",
          add: true,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "customer_list_group_id",
          name: "ブループ名",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "customer_list_group_name",
          name: "リストID-ブループ名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
      ],
      subTable: [
        {
          subTableAuth: ["マスターアカウント", "スタッフアカウント"],
          mainTableDetail: false,
          mainTableDetailColumn: "",
          subTableColumnName: "リストID一覧",
          subTableColumnLength: "list_id_length",
          detailKey: ["product_id", "customer_list_group_id"],
          subTableColumnNameWidth: "90px",
          subTableDetail: false,
          subTableDetailTitle: "リストID詳細",
          subTableAdd: true,
          subTableAddTitle: "リストID追加",
          subTableAddTitleWidth: "90px",
          subTableEdit: false,
          subTableEditTitle: "リストID編集",
          subTableEditDirect: true,
          subTableEditDirectKey: "customer_list_id",
          subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
          tableFunction: [],
          subDataColumn: [
            {
              key: "id",
              name: "customer_list_id_id",
              table: false,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: null,
              addMessage: "",
            },
            {
              key: "product_id",
              name: "商材名",
              table: false,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "product_id",
              add: true,
              addType: "tableSubId",
              addMessage: "",
            },
            {
              key: "customer_list_group_id",
              name: "ブループ名",
              table: false,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "customer_list_group_id",
              add: true,
              addType: "tableSubId",
              addMessage: "",
            },
            {
              key: "customer_list_id",
              name: "リストID",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: true,
              addType: "text",
              addMessage: "",
            },
          ],
          subTable: [],
        },
      ],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "支払方法一覧",
      subTableColumnLength: "payment_method_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "90px",
      subTableDetail: false,
      subTableDetailTitle: "支払方法詳細",
      subTableAdd: true,
      subTableAddTitle: "支払方法追加",
      subTableAddTitleWidth: "90px",
      subTableEdit: false,
      subTableEditTitle: "支払方法編集",
      subTableEditDirect: true,
      subTableEditDirectKey: "payment_method",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [],
      subDataColumn: [
        {
          key: "product_id",
          name: "商材名",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "product_id",
          add: true,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "payment_method",
          name: "支払方法",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: null,
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "解約SMS一覧",
      subTableColumnLength: "cancell_sms_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "90px",
      subTableDetail: true,
      subTableDetailTitle: "解約SMS詳細",
      subTableAdd: true,
      subTableAddTitle: "解約SMS追加",
      subTableAddTitleWidth: "90px",
      subTableEdit: false,
      subTableEditTitle: "解約SMS編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [
        {
          name: "削除",
          auth: ["マスターアカウント", "スタッフアカウント"],
        },
      ],
      subDataColumn: [
        {
          key: "product_id",
          name: "商材ID",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "",
          add: true,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "cancell_sms_name",
          name: "解約SMS識別名称",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "※内部で使用する識別名称です。顧客からは見えません。",
        },
        {
          key: "cancell_sms_type",
          name: "SMSタイプ",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "list",
          addMessage: "",
        },
        {
          key: "cancell_sms_auth",
          name: "承認状況",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "cancell_sms_sender",
          name: "送信元ID・メールアドレス",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage:
            "※ショートメッセージの場合は「送信元ID」、メールの場合は「メールアドレス」を入力してください。",
        },
        {
          key: "cancell_sms_title",
          name: "メールタイトル",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage:
            "※メールの場合のみ。埋め込み可能：{{顧客氏名}}、{{商材名}}、{{申込番号}}、{{解約日}}",
        },
        {
          key: "cancell_sms_body",
          name: "本文",
          table: false,
          tableValue: null,
          detail: true,
          edit: true,
          editType: "multitext",
          editId: "id",
          add: true,
          addType: "multitext",
          addMessage:
            "※埋め込み可能：{{顧客氏名}}、{{商材名}}、{{申込番号}}、{{解約日}}",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "トスアップパートナー一覧",
      subTableColumnLength: "toss_up_sale_company_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "170px",
      subTableDetail: false,
      subTableDetailTitle: "トスアップパートナー詳細",
      subTableAdd: true,
      subTableAddTitle: "トスアップパートナー追加",
      subTableAddTitleWidth: "170px",
      subTableEdit: false,
      subTableEditTitle: "トスアップパートナー編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: [],
      tableFunction: [],
      subDataColumn: [
        {
          key: "product_id",
          name: "商材ID",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "",
          add: false,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "sale_company_id",
          name: "パートナー名",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "sale_company_name",
          name: "パートナー名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "toss_up_sale_company",
          addMessage: "",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "エントリーパートナー一覧",
      subTableColumnLength: "entry_sale_company_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "170px",
      subTableDetail: false,
      subTableDetailTitle: "エントリーパートナー詳細",
      subTableAdd: true,
      subTableAddTitle: "エントリーパートナー追加",
      subTableAddTitleWidth: "170px",
      subTableEdit: false,
      subTableEditTitle: "エントリーパートナー編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: [],
      tableFunction: [],
      subDataColumn: [
        {
          key: "product_id",
          name: "商材ID",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "",
          add: false,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "sale_company_id",
          name: "パートナー名",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "sale_company_name",
          name: "パートナー名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "entry_sale_company",
          addMessage: "",
        },
      ],
      subTable: [],
    },
  ],
};
